const mediaPlayerSchema = (props = {}) => ({
  title: 'Media Player',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['file', 'playerType', 'title', 'caption', 'description'],
    },
    {
      id: 'settings',
      title: 'Player Settings',
      fields: ['controls', 'autoplay', 'loop', 'muted', 'preload'],
    },
    {
      id: 'layout',
      title: 'Layout',
      fields: ['blockWidth', 'width', 'height', 'borderRadius'],
    },
  ],
  properties: {
    blockWidth: {
      title: 'Block Width',
      description: 'Set the container width for the entire media player block',
      type: 'string',
      choices: [
        ['default', 'Default (Medium)'],
        ['narrow', 'Narrow'],
        ['wide', 'Wide'],
      ],
      default: 'default',
    },
    file: {
      title: 'Media File',
      description: 'Select an audio or video file',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
      multi: false,
    },
    playerType: {
      title: 'Player Type',
      description:
        'Choose the type of player or let it auto-detect from the file',
      type: 'string',
      choices: [
        ['auto', 'Auto-detect from file'],
        ['video', 'Video Player'],
        ['audio', 'Audio Player'],
      ],
      default: 'auto',
    },
    title: {
      title: 'Title',
      description: 'Optional title to display above the player',
      type: 'string',
    },
    caption: {
      title: 'Caption',
      description: 'Optional caption to display below the player',
      type: 'text',
    },
    description: {
      title: 'Description',
      description: 'Optional description to display below the player',
      type: 'text',
    },
    controls: {
      title: 'Show Controls',
      description: 'Display player controls (play, pause, volume, etc.)',
      type: 'boolean',
      default: true,
    },
    autoplay: {
      title: 'Autoplay',
      description: 'Start playing automatically when the page loads',
      type: 'boolean',
      default: false,
    },
    loop: {
      title: 'Loop',
      description: 'Repeat the media when it ends',
      type: 'boolean',
      default: false,
    },
    muted: {
      title: 'Muted',
      description: 'Start with audio muted',
      type: 'boolean',
      default: false,
    },
    preload: {
      title: 'Preload',
      description: 'How much of the media to load when the page loads',
      type: 'string',
      choices: [
        ['none', "None - Don't preload"],
        ['metadata', 'Metadata - Load only metadata'],
        ['auto', 'Auto - Load entire file'],
      ],
      default: 'metadata',
    },
    width: {
      title: 'Width',
      description: 'Player width (e.g., 100%, 500px)',
      type: 'string',
      default: '100%',
    },
    height: {
      title: 'Height (Video Only)',
      description: 'Player height for video (e.g., 400px, 50vh)',
      type: 'string',
      default: '400px',
    },
    borderRadius: {
      title: 'Border Radius',
      description: 'Rounded corners (e.g., 8px, 16px)',
      type: 'string',
      default: '8px',
    },
  },
  required: ['file'],
});

export default mediaPlayerSchema;
